import React from 'react';
import ReactFC from "react-fusioncharts";

// Include the fusioncharts library
import FusionCharts from "fusioncharts";

// Include the chart type
import Chart from "fusioncharts/fusioncharts.charts";

// Include the theme as fusion
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";

// Adding the chart and theme as dependency to the core fusioncharts
ReactFC.fcRoot(FusionCharts, Chart, FusionTheme);


const Bar3D = ({data}) => {
   const chartConfigs = {
  type: "bar3d", // The chart type
  width: "100%", // Width of the chart
  height: "400", // Height of the chart
  dataFormat: "json", // Data type
  dataSource: {
    // Chart Configuration
    chart: {
      caption:"Most Forked",
      yAxisName:"Forks",
      xAxisName:"Repos",
      xAxisNameFontSize:"13px",
      yAxisNameFontSize:"13px",
      // paletteColors:'#f0db4f,' provide more colors otherwse repetition will occur

    },
    // Chart Data
    data
  }
};
  return (
    <ReactFC {...chartConfigs } />
  );
};

export default Bar3D;
